import { Directive, forwardRef, HostListener } from '@angular/core';
import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[trimValueAccessor]',
  standalone: true,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TrimValueAccessorDirective),
    multi: true
  }]
})

export class TrimValueAccessorDirective extends DefaultValueAccessor {
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.onChange?.(typeof value === 'string' ? value.trim() : value);
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const v = typeof value === 'string' ? value.trim() : value;
    this.writeValue(v);
    this.onTouched?.();
  }

  override writeValue(value: any): void {
    const v = typeof value === 'string' ? value.trim() : value;
    super.writeValue(v);
  }
}
